import { GetAdminPayupsResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseAdminPayupsParams {
	page: number
	pageSize?: number
}

/**
 * Fetches a page of the admin payups list (GET /v1/admin/payups), scoped to the
 * global creation-date range from {@link useAdminFilter} plus the caller's page.
 * Previous data is kept while the next page loads. Gated server-side by the
 * AdminGuard; non-admins receive 403.
 */
export const useAdminPayups = ({ page, pageSize }: UseAdminPayupsParams) => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminPayupsResponse>({
		queryKey: queryKeys.adminPayups(from, to, page, pageSize, includeInternal),
		queryFn: async () => {
			const response = await api.get<GetAdminPayupsResponse>('/admin/payups', {
				params: { from, to, page, pageSize, includeInternal: includeInternal || undefined },
			})
			return response.data
		},
		placeholderData: keepPreviousData,
	})
}
